import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=2c07355c&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=2c07355c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07355c",
  null
  
)

export default component.exports